module.exports = __webpack_public_path__ + "img/logo.50ad8300.png";